import React, { Component } from 'react';

// import { connect } from 'react-redux';

// import * as Customers from '../../Store/Customers';
// import * as Responses from '../../Store/Responses';
// import * as Monies from '../../Store/Monies';

// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";

import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ja from "date-fns/locale/ja";

import './Css/Table.css';

import DatePicker from "react-datepicker";
interface Props {

    handleSubmit: any,
    onSubmit: any,
    get_rent_contract_accounting: any,
    output: any,
    name: string,
    date1: string,
    date2: string
}

const ReduxFormDateRange = (props: any) => {


    console.log(props)
    return (

        // <DatePicker

        //     selected={props.input.value !== "" ? new Date(props.input.value) : null}
        //     //selected={moment(props.input.value, "YYYY-MM-DD").format("YYYY-MM-DD") || null}
        //     onChange={props.input.onChange}
        //     //showTimeSelect
        //     dateFormat="yyyy/MM/dd"
        //     className="form-control"
        // />

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy/MM/dd"
                margin="normal"
                id="date-picker-estimate2"
                // label="契約日"
                //   showTodayButton={true}
                // style={{ float: "left" }}
                // error={true}
                // helperText="契約日を選択してください"
                //   errorMessages={['契約日を選択してください']}
                name="contractDataStart"
                autoOk={true}
                //    onChange={this.handleContractionDateChangeStart}
                // value={this.props.search_contract_date_start}
                value={props.input.value !== "" ? new Date(props.input.value) : null}
                onChange={props.input.onChange}
                KeyboardButtonProps={{
                'aria-label': 'change date',
                }}
                //   minDateMessage="契約日を選択してください"
                // minDate={new Date("2000-01-01")}
                invalidDateMessage={"日付の形式が違います"}
        />
        </MuiPickersUtilsProvider>

    )
}

interface State {

}


class AccountingListSearchComponent extends Component<InjectedFormProps<Props, {}, string>>  {

    //         constructor(props: Readonly<Props>) {
    //             // super(props);
    // }

    componentWillMount() {

        this.props.initialize({ output: true, name: "", date1: "", date2: "" });//フォームに初期値を反映させる


    }

    render() {

        const { handleSubmit } = this.props;


        return (
            <div>
                <form onSubmit={handleSubmit}  >
                    <table>

                        <tbody>

                            <tr >
                                <th>お客様名</th>
                                <td colSpan={3}>
                                    <Field
                                        name="name"
                                        component="input"
                                        type="text"
                                        //placeholder=""
                                        className="form-control"
                                    />
                                </td>

                            </tr>


                            <tr >
                                <th>データ未作成</th>
                                <td >
                                    <Field name="output" id="output" component="input" type="checkbox" />


                                </td>
                            </tr >


                            <tr >
                                <th>取込期間</th>
                                <td > <Field
                                    name="date1"
                                    id="date1"
                                    component={ReduxFormDateRange}
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                />～
                                    <Field
                                        name="date2"
                                        id="date2"
                                        component={ReduxFormDateRange}
                                        type="text"
                                        placeholder=""
                                        className="form-control"
                                    />

                                </td>
                            </tr >

                        </tbody>
                    </table>
                    <button
                        type="submit"
                        className="btn btn-primary float-right"
                    >検索</button>



                </form>





            </div>
        );
    }
}




// const mapStateToProps = (state:any) => {
//     return {

//         responseid: state.customersReducer.responseid,
//         responsedetail: state.customersReducer.responsedetail,
//         customerNewDisp: state.customersReducer.customerNewDisp,
//         customerdetail0: state.customersReducer.customerdetail0

//     }
// }
// function mapDispatchToProps(dispatch:any) {
//     return {

//         // responseUpdate(state:any) {
//         //     dispatch(Responses.responseUpdate(state))
//         // },
//         // change_customerloding1(state:number) {
//         //     dispatch(Customers.change_customerloding1(state))
//         // },
//         // change_customerloding2(state:number) {
//         //     dispatch(Customers.change_customerloding2(state))
//         // },
//         // customerNewDispSet(state:number) {
//         //     dispatch(Customers.customerNewDispSet(state))
//         // },
//         // change_customeredit0(state:number) {
//         //     dispatch(Customers.change_customeredit0(state))
//         // },
//        get_rent_contract_accounting(state:any) {
//             dispatch(Monies.get_rent_contract_accounting(state))
//         },

//     };
// }
// AccountingListSearchComponent = connect(
//     mapStateToProps, mapDispatchToProps
// )(AccountingListSearchComponent);
export default reduxForm<Props>({
    form: 'formset',

})(AccountingListSearchComponent);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

